import { esc } from "./utils.js";

/** Must match Report.REASONS in app/models.py — the API rejects anything else. */
const REASONS = [
  ["spam", "Spam or advertising"],
  ["harassment", "Harassment or abuse"],
  ["inappropriate", "Inappropriate content"],
  ["misinformation", "Misleading or unsafe information"],
  ["other", "Something else"],
];

/**
 * Asks what is wrong with a piece of content.
 *
 * Resolves to { reason, details } or null if dismissed. A reason must be
 * picked deliberately — nothing is preselected, because a default would
 * get submitted unread and the reason is what routes a moderator's
 * attention.
 */
export function reportDialog({ what = "post", snippet = "" } = {}) {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    host.innerHTML = `
      <div class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Report this ${esc(what)}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form>
              <div class="modal-body">
                ${snippet
                  ? `<blockquote class="border-start border-3 ps-3 text-slate small mb-3 dc-user-text">${esc(snippet)}</blockquote>`
                  : ""}
                <p class="mb-2">What's the problem?</p>
                ${REASONS.map(
                  ([value, label], i) => `
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="report-reason"
                           id="report-reason-${i}" value="${value}" required />
                    <label class="form-check-label" for="report-reason-${i}">${esc(label)}</label>
                  </div>`
                ).join("")}
                <div class="mt-3">
                  <label class="form-label" for="report-details">Anything else? (optional)</label>
                  <textarea class="form-control" id="report-details" rows="3" maxlength="2000"></textarea>
                </div>
                <p class="text-slate small mt-3 mb-0">
                  This goes to the site moderators. If it's in a cohort, that
                  cohort's admins are told what was reported — but not who
                  reported it.
                </p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-danger">Send report</button>
              </div>
            </form>
          </div>
        </div>
      </div>`;
    const el = host.firstElementChild;
    document.body.appendChild(el);
    const modal = new bootstrap.Modal(el);

    let result = null;
    el.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();
      const picked = el.querySelector("input[name='report-reason']:checked");
      if (!picked) return; // `required` normally catches this
      result = {
        reason: picked.value,
        details: el.querySelector("#report-details").value.trim() || null,
      };
      modal.hide();
    });
    // Resolving on hide means Escape and backdrop dismissal settle exactly
    // once, and the node is always removed.
    el.addEventListener("hidden.bs.modal", () => {
      el.remove();
      resolve(result);
    });
    modal.show();
  });
}
